'use client';

export function calculateBrowserWidth(): number {
  return window.innerWidth && document.documentElement.clientWidth
    ? Math.min(window.innerWidth, document.documentElement.clientWidth)
    : window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
}

export function isSubscribePage() {
  return ['/subscribe/', '/paid-subscribe/', '/email-subscribe/'].some((path) =>
    window.location.pathname.includes(path),
  );
}

/**
 * Determines if a user has an active subscription.
 * Returns true if the user is logged in AND has either an active subscription or is in a paused state.
 */
export function isUserSubscribed(
  loggedIn: boolean | undefined,
  hasAccess: boolean | null,
  isPaused: boolean | null,
): boolean {
  const hasAccessOrPaused = (hasAccess ?? false) || (isPaused ?? false);
  return loggedIn === true && hasAccessOrPaused;
}
